(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[134],{

/***/ 5115:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news",
      function () {
        return __webpack_require__(1141);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SEO_SEO; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./lib/seo-config.js
var SITE_CONFIG = {
    name: "Evry Health",
    url: "https://www.evryhealth.com",
    defaultOgImage: "https://www.evryhealth.com/og-image.png",
    twitterCard: "summary_large_image"
};
var PAGE_SEO = {
    "": {
        title: "Evry Health | Modern Health Insurance for Texas Employers & Members",
        description: "Evry Health offers transparent, member-first health insurance for Texas employers (51+ employees) and their members — with $0 telehealth, no copays, no deductibles, and a personalized care team.",
        ogDescription: "Transparent, member-first health insurance for Texas employers and members. No copays. No deductibles. $0 telehealth.",
        twitterTitle: "Evry Health",
        twitterDescription: "Modern health insurance for Texas employers and members."
    },
    "admission-notification": {
        title: "Inpatient Admission Notification | Evry Health",
        description: "How to submit inpatient admission notifications to Evry Health to ensure timely, accurate claims processing.",
        ogDescription: "How to submit inpatient admission notifications to Evry Health.",
        twitterTitle: "Admission Notification | Evry Health",
        twitterDescription: "Submit inpatient admission notifications to Evry Health."
    },
    careers: {
        title: "Careers at Evry Health | Join Our Team",
        description: "We're making health insurance work again. Explore open roles at Evry Health in Dallas, Texas.",
        twitterTitle: "Careers at Evry Health",
        twitterDescription: "Explore open roles at Evry Health in Dallas, Texas."
    },
    "community-resources": {
        title: "Texas Community Resources for Members | Evry Health",
        description: "A curated list of local community, health, food, and legal resources across Texas for Evry Health members.",
        twitterTitle: "Texas Community Resources | Evry Health",
        twitterDescription: "Community, health, food, and legal resources for Evry Health members in Texas."
    },
    "contact-us": {
        title: "Contact Evry Health | Get a Quote",
        description: "Get in touch with Evry Health for plan quotes, member support, or general questions. Call 1-855-579-3879.",
        ogDescription: "Get in touch with Evry Health for plan quotes, member support, or general questions.",
        twitterTitle: "Contact Evry Health",
        twitterDescription: "Get a quote or ask us anything. Call 1-855-579-3879."
    },
    faqs: {
        title: "Frequently Asked Questions | Evry Health",
        description: "Answers to common questions about Evry Health plans, coverage, virtual care, and member benefits.",
        twitterDescription: "Answers to common questions about Evry Health plans and coverage."
    },
    forms: {
        title: "Forms & Notices | Evry Health",
        description: "Download member and provider forms, notices, and resources from Evry Health.",
        twitterDescription: "Download forms and notices from Evry Health."
    },
    fwa: {
        title: "Report Fraud, Waste & Abuse | Evry Health",
        description: "How Evry Health members and providers can report suspected fraud, waste, or abuse.",
        twitterDescription: "Report suspected fraud, waste, or abuse to Evry Health."
    },
    "how-we-compare": {
        title: "How Evry Health Compares | Plan Comparison",
        description: "Compare Evry Health plans against traditional carriers — no deductibles, no copays, $0 virtual care, and transparent premiums.",
        ogDescription: "Compare Evry Health plans against traditional carriers — no deductibles, no copays, $0 virtual care.",
        twitterTitle: "How Evry Health Compares",
        twitterDescription: "Compare Evry Health plans against traditional carriers."
    },
    "how-we-do-it": {
        title: "How Evry Health Works | Built for Modern Workforces",
        description: "Evry Health is built for the modern business and the mobile workforce. See how our health insurance plans work.",
        twitterTitle: "How Evry Health Works",
        twitterDescription: "Built for the modern business and the mobile workforce."
    },
    "join-the-evry-network": {
        title: "Join the Evry Health Provider Network",
        description: "Apply to join the Evry Health provider network. Faster payments. Transparent terms.",
        twitterTitle: "Join the Evry Health Network",
        twitterDescription: "Apply to join the Evry Health provider network."
    },
    login: {
        title: "Sign In | Evry Health",
        description: "Sign in to the Evry Health member portal.",
        noindex: true
    },
    "meet-your-new-team": {
        title: "Meet Your Evry Health Care Team",
        description: "Every Evry Health member gets a dedicated team of nurses, nutritionists, and doctors — included at no extra cost.",
        ogDescription: "Every member gets a dedicated team of nurses, nutritionists, and doctors — at no extra cost.",
        twitterDescription: "A dedicated team of nurses, nutritionists, and doctors — included at no extra cost."
    },
    members: {
        title: "Member Registration | Evry Health",
        description: "Register for your Evry Health member portal account.",
        noindex: true
    },
    mobileapp: {
        title: "Evry Health Mobile App | Manage Your Plan On the Go",
        description: "Download the Evry Health mobile app to view your ID card, find providers, message your care team, and more.",
        ogDescription: "Download the Evry Health mobile app to view your ID card, find providers, and message your care team.",
        twitterTitle: "Evry Health Mobile App",
        twitterDescription: "Manage your health plan on the go with the Evry Health app."
    },
    news: {
        title: "News & Press | Evry Health",
        description: "The latest news, press releases, and announcements from Evry Health.",
        twitterDescription: "The latest news and announcements from Evry Health."
    },
    "non-discrimination-policy": {
        title: "Non-Discrimination Policy | Evry Health",
        description: "Evry Health's commitment to non-discrimination and language assistance for members.",
        twitterDescription: "Non-discrimination and language assistance for all members."
    },
    "our-story": {
        title: "Our Story | Evry Health",
        description: "Evry Health is on a mission to build the health insurance company we've always wanted for ourselves.",
        ogDescription: "We're on a mission to build the health insurance company we've always wanted for ourselves.",
        twitterDescription: "Building the health insurance company we've always wanted."
    },
    partners: {
        title: "Partners | Evry Health",
        description: "The partners and providers Evry Health works with to deliver modern health insurance.",
        twitterDescription: "Partners and providers delivering modern health insurance."
    },
    "prior-auth-list-updates": {
        title: "Prior Authorization List Updates | Evry Health",
        description: "Recent updates to the Evry Health prior authorization list for providers.",
        twitterDescription: "Recent updates to the prior authorization list for providers."
    },
    "prior-auth-tool": {
        title: "Prior Authorization Tool | Evry Health for Providers",
        description: "Look up whether a procedure requires prior authorization with Evry Health.",
        twitterTitle: "Prior Authorization Tool | Evry Health",
        twitterDescription: "Check if prior authorization is required for a procedure."
    },
    "prior-authorization": {
        title: "Prior Authorization | Evry Health for Providers",
        description: "Information for providers on which procedures require prior authorization with Evry Health.",
        ogDescription: "Provider resources for prior authorization with Evry Health.",
        twitterTitle: "Prior Authorization | Evry Health",
        twitterDescription: "Provider resources for prior authorization with Evry Health."
    },
    "privacy-policy": {
        title: "Privacy Policy | Evry Health",
        description: "How Evry Health collects, uses, and protects your personal and health information.",
        twitterDescription: "How Evry Health protects your personal and health information."
    },
    providerdirectory: {
        title: "Provider Directory | Evry Health",
        description: "Find in-network providers with the Evry Health provider directory.",
        noindex: true
    },
    "request-to-join": {
        title: "Request to Join | Evry Health Network",
        description: "Submit a request to join the Evry Health provider network. Simple application process.",
        ogDescription: "Submit a request to join the Evry Health provider network.",
        twitterTitle: "Request to Join | Evry Health",
        twitterDescription: "Join the Evry Health provider network."
    },
    "retrospective-reviews": {
        title: "Retrospective Reviews | Evry Health for Providers",
        description: "Learn how Evry Health determines coverage after treatment has been provided.",
        twitterTitle: "Retrospective Reviews | Evry Health",
        twitterDescription: "How Evry Health determines coverage after treatment."
    },
    rewards: {
        title: "Member Rewards | Evry Health",
        description: "Earn rewards for staying healthy as an Evry Health member.",
        twitterDescription: "Earn rewards for staying healthy with Evry Health."
    },
    terms: {
        title: "Terms of Use | Evry Health",
        description: "Terms of use for the Evry Health website and digital services.",
        twitterDescription: "Terms of use for Evry Health website and services."
    },
    "virtual-care": {
        title: "$0 Virtual Care & Telehealth | Evry Health",
        description: "Talk to a board-certified physician 24/7 for $0. On-demand virtual care included with every Evry Health plan.",
        twitterDescription: "Talk to a board-certified physician 24/7 for $0."
    },
    "why-choose-evry": {
        title: "Why Choose Evry Health | Texas Health Insurance",
        description: "See why Texas employers choose Evry Health: no copays, no deductibles, $0 telehealth, and a personalized member care team.",
        twitterTitle: "Why Choose Evry Health",
        twitterDescription: "See why Texas employers choose Evry Health: no copays, no deductibles, $0 telehealth."
    }
};
function getPageSeo(slug) {
    var page = PAGE_SEO[slug] || {};
    var title = page.title || SITE_CONFIG.name;
    var description = page.description || "";
    var ogTitle = page.ogTitle || title;
    var ogDescription = page.ogDescription || description;
    var ogImage = page.ogImage || SITE_CONFIG.defaultOgImage;
    var twitterTitle = page.twitterTitle || ogTitle;
    var twitterDescription = page.twitterDescription || ogDescription;
    var twitterImage = page.twitterImage || ogImage;
    var noindex = page.noindex || false;
    var url = slug === "" ? "".concat(SITE_CONFIG.url, "/") : "".concat(SITE_CONFIG.url, "/").concat(slug);
    return {
        title: title,
        description: description,
        url: url,
        ogTitle: ogTitle,
        ogDescription: ogDescription,
        ogImage: ogImage,
        twitterTitle: twitterTitle,
        twitterDescription: twitterDescription,
        twitterImage: twitterImage,
        noindex: noindex
    };
}

;// CONCATENATED MODULE: ./components/SEO/SEO.js





var SEO = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, slug = ref.slug, overrides = ref.overrides;
    var router = (0,next_router.useRouter)();
    var resolvedSlug = slug !== undefined ? slug : router.pathname.replace(/^\//, "");
    var resolved = getPageSeo(resolvedSlug);
    var seo = overrides ? (0,_object_spread/* default */.Z)({}, resolved, overrides) : resolved;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: seo.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: seo.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: seo.ogTitle
            }, "title"),
            seo.noindex && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: "noindex,follow"
            }),
            !seo.noindex && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: seo.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: SITE_CONFIG.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: seo.url
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: seo.ogDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: seo.ogImage
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: SITE_CONFIG.twitterCard
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: seo.twitterTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: seo.twitterDescription
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: seo.twitterImage
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SEO_SEO = (SEO);


/***/ }),

/***/ 1141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ news; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/SEO/SEO.js + 1 modules
var SEO = __webpack_require__(3976);
;// CONCATENATED MODULE: ./components/Card/InfoCard.js

var InfoCard = function(props) {
    var image = props.image, altText = props.altText, title = props.title, description = props.description, link = props.link, _linkText = props.linkText, linkText = _linkText === void 0 ? "Read more" : _linkText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-grey-light rounded-sm shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden h-full flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "p-8 flex items-center justify-center h-32",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: image,
                    alt: altText,
                    className: "max-w-32 max-h-20 min-w-16 min-h-8 object-contain"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-6 flex-1 flex flex-col",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        dangerouslySetInnerHTML: {
                            __html: title
                        },
                        className: "text-blue-dark text-xl font-extralight tracking-tight leading-tight mb-4 flex-shrink-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        dangerouslySetInnerHTML: {
                            __html: description
                        },
                        className: "text-grey text-sm leading-relaxed mb-6 flex-1 line-clamp-4 overflow-hidden"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: link,
                        target: "_blank",
                        rel: "noreferrer",
                        className: "text-blue hover:text-blue-light font-bold text-sm font-[sans-serif] inline-flex items-center mt-auto",
                        children: [
                            linkText,
                            " →"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Card_InfoCard = (InfoCard);

// EXTERNAL MODULE: ./layout/Layout.js + 6 modules
var Layout = __webpack_require__(9875);
;// CONCATENATED MODULE: ./resources/newsInfo.js
// @ts-check
// /**
//  * @typedef {{
//  *  companyLogo: string,
//  *  companyLogoAltText: string,
//  * articleTitle: string,
//  * articleSummary: string,
//  * articleLink: string,
//  * }} NewsInfo
//  */
// /**
//  * @type {[]<NewsInfo>}
//  */
var newsInfo = [
    {
        companyLogo: "longhorn-100-logo.jpg",
        companyLogoAltText: "Longhorn 100 logo",
        articleTitle: "2026 Longhorn 100 — #29 Fastest Growing Longhorn Business",
        articleSummary: "Evry Health was named #29 on the 2026 Longhorn 100, which showcases and celebrates the entrepreneurial spirit of UT alumni by recognizing the 100 fastest-growing Longhorn businesses in the world.",
        articleLink: "https://www.texasexes.org/longhorn100/2026"
    },
    {
        companyLogo: "D-Magazine-Logo.png",
        companyLogoAltText: "D Magazine Logo",
        articleTitle: "Inside Evry Health's Push to Streamline Prior Authorization Through AI",
        articleSummary: "With denial rates at 4 percent in 2025, the Dallas-based, tech-forward insurer is outperforming national averages.",
        articleLink: "https://www.dmagazine.com/healthcare-business/2026/05/inside-evry-healths-push-to-streamline-prior-authorization-through-ai/"
    },
    {
        companyLogo: "dallas_business_journal_logo.jpeg",
        companyLogoAltText: "Dallas Business Journal logo",
        articleTitle: "Dallas Business Journal C-Suite Leaders Award",
        articleSummary: "Evry Health's CEO, Chris Gay, is one of thirty honorees.",
        articleLink: "https://www.bizjournals.com/dallas/news/2025/08/27/2025-c-suite-leaders-awards-winners-revealed.html"
    },
    {
        companyLogo: "beckers_payer_issues_podcast_logo.png",
        companyLogoAltText: "beckers payer issues podcast logo",
        articleTitle: "Rethinking Prior Authorization Through Technology and Alignment with Chris Gay of Evry Health",
        articleSummary: "What if we could eliminate prior authorizations altogether? We discuss PAs, WISeR, and state versus federal regulation. Listen on Apple Podcasts or Spotify.",
        articleLink: "https://podcasts.apple.com/us/podcast/rethinking-prior-authorization-through-technology-and/id1519506579?i=1000743205904",
        linkText: "Listen"
    },
    {
        companyLogo: "ceo_spotlight_podcast_logo.png",
        companyLogoAltText: "ceo spotlight podcast logo",
        articleTitle: "KLRD 1080 AM, CEO Spotlight",
        articleSummary: "Healthcare is Ill: David Johnson of Dallas' KLRD radio interviews Chris Gay on July 25, 2025, for the CEO Spotlight.",
        articleLink: "https://www.audacy.com/podcast/ceo-spotlight-34d13/episodes/healthcare-is-ill-b47a6",
        linkText: "Listen"
    },
    {
        companyLogo: "beckers_payer_issues_podcast_logo.png",
        companyLogoAltText: "beckers payer issues podcast logo",
        articleTitle: "Chris Gay, CEO of Evry Health",
        articleSummary: "Chris Gay, CEO of Evry Health, joins the podcast to discuss how his organization is enhancing the patient experience and advancing population health. He explores how innovative technology is being used to address persistent challenges in the payer space and improve health outcomes. Gay also shares insights into building a more efficient, patient-centered healthcare system through digital transformation.",
        articleLink: "https://podcasts.apple.com/us/podcast/chris-gay-ceo-of-evry-health/id1519506579?i=1000715809623",
        linkText: "Listen"
    },
    {
        companyLogo: "beckers-payer-issues-logo.png",
        companyLogoAltText: "beckers payer issues logo",
        articleTitle: "How a Texas payer cut prior auth denials to 7% ahead of industry reform pledge",
        articleSummary: "Ahead of the health insurance industry’s broader pledge to overhaul prior authorization processes, one Texas payer has already achieved a 7% prior authorization denial rate, with 100% of those denials upheld upon appeal.",
        articleLink: "https://www.beckerspayer.com/payer/how-a-texas-payer-cut-prior-auth-denials-to-7-ahead-of-industry-reform-pledge/"
    },
    {
        companyLogo: "ahip-logo.png",
        companyLogoAltText: "ahip logo",
        articleTitle: "Health plans are making voluntary commitments to support patients and providers.",
        articleSummary: "The undersigned health plans commit to actions that will make health care faster and simpler.",
        articleLink: "https://www.ahip.org/health-plans-are-making-voluntary-commitments-to-support-patients-and-providers"
    },
    {
        companyLogo: "bhbusiness-logo.png",
        companyLogoAltText: "bh business logo",
        articleTitle: "Prior Authorization Overhaul to Debut in 2026, with Broader Reform for Behavioral Health on the Horizon",
        articleSummary: "Preventing unnecessary care and medication prescriptions is the primary purpose of prior authorization. Instead, it has all too often led to slower, burdensome delays to critical care for mental health and substance use treatment, but that could soon change.",
        articleLink: "https://bhbusiness.com/2025/06/24/prior-authorization-overhaul-to-debut-in-2026-with-broader-reform-for-behavioral-health-on-the-horizon/"
    },
    {
        companyLogo: "Dallas-Innovates-logo.png",
        companyLogoAltText: "Dallas Innovates Logo",
        articleTitle: "Evry Health Names Air Force Veteran Healthcare Leader as Chief Medical Officer",
        articleSummary: "Glenn Hamilton, MD—who held the role of chief medical officer at the San Antonio Air Logistics Center during Desert Storm—will oversee all aspects of population health, utilization management, and clinical policy at Evry Health, the Dallas-based company said.",
        articleLink: "https://dallasinnovates.com/evry-health-names-air-force-veteran-healthcare-leader-as-chief-medical-officer/"
    },
    {
        companyLogo: "dallas-morning-news-logo.png",
        companyLogoAltText: "The Dallas Morning News Logo",
        articleTitle: "McKinney-based Globe Life moving to new HQ",
        articleSummary: "Globe Life announced plans Monday to acquire a Class AA, six-story, 200,000-square-foot office building at 7677 Henneman Way and two adjacent tracts of land. SouthState Bank is the seller in the transaction, Globe Life said.",
        articleLink: "https://www.dallasnews.com/business/real-estate/2025/02/03/mckinney-based-globe-life-moving-to-new-hq/"
    },
    {
        companyLogo: "D-Magazine-Logo.png",
        companyLogoAltText: "D Magazine Logo",
        articleTitle: "Evry Health Names Chief Growth Officer",
        articleSummary: "Evry Health, a leading tech-forward business-to-business health insurance company, has named Christina Rassi its new Chief Growth Officer. With over two decades of experience with health insurance carriers.",
        articleLink: "https://www.dmagazine.com/healthcare-business/2024/03/evry-health-names-chief-growth-officer-and-unt-regents-approve-nursing-degree-programs/"
    },
    {
        companyLogo: "Business-Wire-Logo.png",
        companyLogoAltText: "Business Wire Logo",
        articleTitle: "Evry Health Welcomes Veteran Healthcare Leader as New Chief Growth Officer",
        articleSummary: "Evry Health, a tech-forward business-to-business health insurance company, announced the appointment of its new Chief Growth Officer, Christina Rassi.",
        articleLink: "https://www.businesswire.com/news/home/20240318523183/en/"
    },
    {
        companyLogo: "Dallas-Innovates-logo.png",
        companyLogoAltText: "Dallas Innovates Logo",
        articleTitle: "Evry Health Appoints New Chief Growth Officer",
        articleSummary: "The leadership addition of Christina Rassi as chief growth officer adds further momentum for Dallas-based Evry Health, following its acquisition by Globe Life last fall.",
        articleLink: "https://dallasinnovates.com/evry-health-appoints-new-chief-growth-officer/"
    },
    {
        companyLogo: "D-CEO-LOGO.png",
        companyLogoAltText: "D CEO logo",
        articleTitle: "Meet the Dallas 500",
        articleSummary: "Chris Gay is on a mission to digitize health insurance in his role as CEO of Evry Health.",
        articleLink: "https://www.dmagazine.com/healthcare-business/2024/02/meet-the-500-chris-gay-evry-health/"
    },
    {
        companyLogo: "Icon-for-The-Vax-Show.png",
        companyLogoAltText: "The vax show logo",
        articleTitle: "Chris Gay on The Vax Show",
        articleSummary: "This week Chris Gay shows us health insurance with ZEROS in the right place for a change! Zero office visit cost. Zero prescription cost. Zero tele-health cost, and a lot more.",
        articleLink: "https://www.linkedin.com/posts/thevax_ep4-this-week-chris-gay-shows-us-health-activity-7157839546540257280-oBu0"
    },
    {
        companyLogo: "Icon-for-Dallas-500.png",
        companyLogoAltText: "D CEO logo",
        articleTitle: "Evry Health and Chris Gay named to D CEO's Dallas 500",
        articleSummary: "Meet the most powerful business leaders in Dallas-Fort Worth.",
        articleLink: "https://www.dmagazine.com/dallas-500-2024/chapter/healthcare/"
    },
    {
        companyLogo: "D-Magazine-Logo.png",
        companyLogoAltText: "D Magazine Logo",
        articleTitle: "Globe Life's Acquisition of Evry Health is Rocket Fuel to its Tech-first Approach",
        articleSummary: "Amid all the Texas Rangers celebrations at Globe Life Park, the McKinney-based insurance company with the rights to the World Series Champion’s stadium made a local acquisition that gives innovative Evry Health a capital injection, allowing it to expand its disruptive approach to health insurance.",
        articleLink: "https://www.dmagazine.com/healthcare-business/2023/11/globe-lifes-acquisition-of-evry-health-is-rocket-fuel-to-its-tech-first-approach/"
    },
    {
        companyLogo: "Business-Wire-Logo.png",
        companyLogoAltText: "Business Wire Logo",
        articleTitle: "How Quit Genius, Evry Health’s 100% At-Risk Deal Prioritizes Engagement and Clinical Outcomes",
        articleSummary: "Digital behavioral health companies are getting creative with contracting to meet the demands of payers and employers.",
        articleLink: "https://bhbusiness.com/2023/04/11/how-quit-genius-evry-healths-100-at-risk-deal-prioritizes-engagement-and-clinical-outcomes/"
    },
    {
        companyLogo: "Dallas-Innovates-logo.png",
        companyLogoAltText: "Dallas Innovates Logo",
        articleTitle: "Globe Life Acquires Dallas-based Mobile-first Insurance Startup Evry Health",
        articleSummary: "Dallas-based Evry Health launched out of stealth in December 2021 to make signing up for healthcare or paying a doctor’s bill 'as easy as ordering a pizza.' Less than two years later, it's becoming part of the Globe Life family of brands.",
        articleLink: "https://dallasinnovates.com/dallas-based-evry-health-wants-to-make-accessing-healthcare-as-easy-as-ordering-a-pizza/"
    },
    {
        companyLogo: "Authority-Magazine-Logo.png",
        companyLogoAltText: "Authority Magazine logo",
        articleTitle: "Thriving as a Woman in a Male-Dominated Industry:  Dr. Mamata Majmundar of Evry Health.",
        articleSummary: "Be passionate, patient, driven, detail-oriented and have a desire to learn new things.",
        articleLink: "https://medium.com/authority-magazine/thriving-as-a-woman-in-a-male-dominated-industry-dr-mamata-majmundar-of-evry-health-on-the-five-90895afd7453"
    },
    {
        companyLogo: "Business-Wire-Logo.png",
        companyLogoAltText: "Business Wire Logo",
        articleTitle: "CareJourney Launches Provider Performance on the Salesforce AppExchange, the World's Leading Enterprise Cloud Marketplace",
        articleSummary: "Customers can now benefit from cost and quality metrics for every provider in the U.S. integrated directly in their Salesforce workflows",
        articleLink: "https://www.businesswire.com/news/home/20220914005237/en/CareJourney-Launches-Provider-Performance-on-the-Salesforce-AppExchange-the-Worlds-Leading-Enterprise-Cloud-Marketplace"
    },
    {
        companyLogo: "PR_Newswire_Navy_Logo.png",
        companyLogoAltText: "PR Newswire Logo",
        articleTitle: "Globe Life Acquires Evry Health",
        articleSummary: "Founded in 2017, Evry Health is a business-to-business health insurance company that differentiates itself from traditional PPOs and HMOs by lowering the cost of healthcare through software automation with a mobile-first experience.",
        articleLink: "https://www.prnewswire.com/news-releases/globe-life-acquires-evry-health-301956623.html"
    },
    {
        companyLogo: "Evry_Health_Type_Only_ RGB_BLUE.svg",
        companyLogoAltText: "Evry health globe life Logo",
        articleTitle: "Evry Health Sponsors 2023 HR Southwest Conference.",
        articleSummary: "Exciting news! We are proud to be the Titanium sponsor of the HR Southwest Conference in Ft Worth, Texas this year!",
        articleLink: "https://www.linkedin.com/feed/update/urn:li:activity:7115697164516827137"
    },
    {
        companyLogo: "Insurance-News-Net-Logo.png",
        companyLogoAltText: "InsuranceNewsNet Logo",
        articleTitle: "Health Tech Disruptor Evry Health Reshapes the Payer Landscape Assisted by PLEXIS Next-Gen CAPS Technology.",
        articleSummary: "Evry Health, a new B2B health insurance company, has eliminated deductibles and co-pays by employing a smarter product design driving robust automation.",
        articleLink: "https://insurancenewsnet.com/oarticle/health-tech-disruptor-evry-health-reshapes-the-payer-landscape-assisted-by-plexis-next-gen-caps-technology"
    },
    {
        companyLogo: "Business-Wire-Logo.png",
        companyLogoAltText: "Business Wire Logo",
        articleTitle: "Business Health Insurance Company Evry Health Expands Texas Coverage to Austin, San Antonio and Houston",
        articleSummary: "DALLAS--(BUSINESS WIRE)--Evry Health, a tech-savvy employer health insurance company, announced today it has expanded its reliable, value-based health care to Austin, Houston and San Antonio. Launched earlier this year with a focus on the Dallas-Fort Worth (DFW) business-to-business market, Evry Health is transforming the healthcare industry with its software automation yielding lowered healthcare costs for businesses, in addition to its model of no deductibles or copays for in-network care and its expansive, tailor-made benefit plans and rewards programs that encourage preventative health and access to care.",
        articleLink: "https://www.businesswire.com/news/home/20220718005669/en/Business-Health-Insurance-Company-Evry-Health-Expands-Texas-Coverage-to-Austin-San-Antonio-and-Houston"
    },
    {
        companyLogo: "Authority-Magazine-Logo.png",
        companyLogoAltText: "Authority Magazine Logo",
        articleTitle: "Health Tech: Chris Gay On How Evry Health's Technology Can Make An Important Impact On Our Overall Wellness",
        articleSummary: "Inrecent years, Big Tech has gotten a bad rep. But of course many tech companies are doing important work making monumental positive changes to society, health, and the environment.",
        articleLink: "https://medium.com/authority-magazine/health-tech-chris-gay-on-how-evry-healths-technology-can-make-an-important-impact-on-our-overall-5e16fb45b170"
    },
    {
        companyLogo: "Benefits-Pro-Magazine-Logo.png",
        companyLogoAltText: "BenefitsPRO Magazine Logo",
        articleTitle: "5 things employers should consider when changing health plans",
        articleSummary: "Buying or changing health insurance plans is a major decision. With so many products and services on the market, it can be difficult to consider what benefits and services employees want coupled with the best care options available at differing price tiers.",
        articleLink: "https://www.benefitspro.com/2022/06/17/5-things-employers-should-consider-when-changing-health-plans/?slreturn=20220901092848"
    },
    {
        companyLogo: "Start-Up-to-Follow-Logo.png",
        companyLogoAltText: "Startup to Follow Logo",
        articleTitle: "This Health Tech Company is Revolutionizing the Health Insurance Industry",
        articleSummary: "Evry Health is a B2B tech-savvy health insurance company that makes health insurance affordable, accessible and high-quality.",
        articleLink: "https://www.startuptofollow.com/article/this-health-tech-company-is-revolutionizing-the-health-insurance-industry"
    },
    {
        companyLogo: "GlobeNewswire-Logo.png",
        companyLogoAltText: "GlobeNewswire Logo",
        articleTitle: "Digital Clinic for Addiction Quit Genius and Tech-Savvy Health Insurance Company Evry Health Partner to Address Drug Addiction and Behavior Modification Head On",
        articleSummary: "NEW YORK and DALLAS, April 06, 2022 (GLOBE NEWSWIRE) -- Quit Genius, the world's first digital clinic for treating multiple substance addictions, and Evry Health, a modern business-to-business health insurance company, announced today they have partnered to deliver Quit Genius solutions to Evry Health's members in Dallas starting in April 2022.",
        articleLink: "https://www.globenewswire.com/news-release/2022/04/06/2417640/0/en/Digital-Clinic-for-Addiction-Quit-Genius-and-Tech-Savvy-Health-Insurance-Company-Evry-Health-Partner-to-Address-Drug-Addiction-and-Behavior-Modification-Head-On.html"
    },
    {
        companyLogo: "MobiHealth-News-Logo.png",
        companyLogoAltText: "MobiHealthNews Logo",
        articleTitle: "Quit Genius expands further into insurer space with new Evry Health deal",
        articleSummary: "Addiction recovery platform Quit Genius is diving into the payer space thanks to a new partnership with B2B insurance company Evry Health. As part of the deal, Evry Health's Dallas-based members will have access to Quit Genius' digital services, which include treatment for tobacco, alcohol and opioid addiction.",
        articleLink: "https://www.mobihealthnews.com/news/quit-genius-expands-further-insurer-space-new-evry-health-deal"
    },
    {
        companyLogo: "D-Magazine-Logo.png",
        companyLogoAltText: "D Magazine Logo",
        articleTitle: "DFW Healthcare Brief: Parkland Rebrand and UTA's Massive Cancer Database",
        articleSummary: "Parkland Health and Hospital System will now do business as Parkland Health.",
        articleLink: "https://www.dmagazine.com/healthcare-business/2022/02/dfw-healthcare-brief-parkland-rebrand-and-utas-massive-cancer-database/"
    },
    {
        companyLogo: "KRLD-AM-Logo.png",
        companyLogoAltText: "KRLD-AM (Dallas, TX) Logo",
        articleTitle: "Chris Gay, Founder & CEO, Evry Health",
        articleSummary: "KRLD CEO Spotlight with Chris Gay, the founder and CEO of Evry Health.",
        articleLink: "https://www.audacy.com/krld/podcasts/ceo-spotlight-743/chris-gay-founder-ceo-evry-health-1086692668"
    },
    {
        companyLogo: "D-Magazine-Logo.png",
        companyLogoAltText: "D Magazine Logo",
        articleTitle: "What If Your Health Insurance Plan Didn't Have a Deductible?",
        articleSummary: "Health insurance deductibles are rising, but a local startup is upending the insurance industry with plans that don't have deductibles and copays.",
        articleLink: "https://www.dmagazine.com/healthcare-business/2021/12/what-if-your-health-insurance-plan-didnt-have-a-deductible/"
    },
    {
        companyLogo: "Dallas-Innovates-logo.png",
        companyLogoAltText: "Dallas Innovates Logo",
        articleTitle: "Dallas-Based Evry Health Wants to Make Accessing Healthcare 'as Easy as Ordering a Pizza'",
        articleSummary: "Signing up for healthcare or paying a doctor's bill should be as easy as ordering a pizza,\" says Chris Gay, co-founder and CEO of Evry Health. His Dallas-based B2B health insurance company has emerged from stealth to make healthcare just that simple—with a high-tech, mobile-first approach focused on preventative health and reducing costs for mid-sized companies.",
        articleLink: "https://dallasinnovates.com/dallas-based-evry-health-wants-to-make-accessing-healthcare-as-easy-as-ordering-a-pizza/"
    },
    {
        companyLogo: "built-in-logo.png",
        companyLogoAltText: "Built In Logo",
        articleTitle: "Dallas-Based B2B Insurance Startup Evry Health Launches From Stealth",
        articleSummary: "Chris Gay, co-founder of Dallas-based pay-per-mile car insurance company MileMeter, recently brought his personalized health insurance startup Evry Health to Dallas businesses.",
        articleLink: "https://builtin.com/dallas-fort-worth/startup-evry-health-launches-from-stealth-112421"
    },
    {
        companyLogo: "Dallas-Business-Journal-Logo.png",
        companyLogoAltText: "Dallas Business Journal Logo",
        articleTitle: "Dallas startup emerges from stealth to take on the health insurance industry",
        articleSummary: "Seeing friends and family pass away exposed dysfunctions in the U.S. health care system for local entrepreneur Chris Gay and his fellow co-founders, leading to the launch of their new Dallas-based venture.",
        articleLink: "https://www.bizjournals.com/dallas/inno/stories/news/2021/11/24/evry-health-chris-gay.html"
    },
    {
        companyLogo: "Health-tech-hotspot-logo.png",
        companyLogoAltText: "HealthTech HotSpot Logo",
        articleTitle: "New Tech-Savvy Health Insurance Company Evry Health Launches in Dallas",
        articleSummary: "DALLAS–(BUSINESS WIRE)–#EvryHealth–Dallas-based Evry Health is serious about delivering reliable, value-based care to Dallas-Fort Worth residents, and recently launched its new, tailor-made healthcare plans via www.evryhealth.com. A business-to-business health insurance company founded in 2017, Evry Health differentiates itself from traditional preferred provider organizations (PPOs) and health maintenance organization (HMOs) by using software automation to lower the cost of healthcare.",
        articleLink: "https://healthtechhotspot.com/new-tech-savvy-health-insurance-company-evry-health-launches-in-dallas/"
    },
    {
        companyLogo: "Business-Wire-Logo.png",
        companyLogoAltText: "Business Wire Logo",
        articleTitle: "New Tech-Savvy Health Insurance Company Evry Health Launches in Dallas",
        articleSummary: "DALLAS--(BUSINESS WIRE)--Dallas-based Evry Health is serious about delivering reliable, value-based care to Dallas-Fort Worth residents, and recently launched its new, tailor-made healthcare plans via www.evryhealth.com.",
        articleLink: "https://www.businesswire.com/news/home/20211117006298/en/New-Tech-Savvy-Health-Insurance-Company-Evry-Health-Launches-in-Dallas"
    },
    {
        companyLogo: "Leaders-playbook-logo_.png",
        companyLogoAltText: "The Leader's Playbook Logo",
        articleTitle: "The Leader's Playbook\nEntrepreneurship and Beyond with Chris Gay",
        articleSummary: "Join us on this episode as Justin is joined by Chris Gay, CEO and Cofounder of Evry Health, to discuss Evry Health, the in's and outs of business and entrepreneurship, and the importance of listening.",
        articleLink: "https://podcastaddict.com/episode/https%3A%2F%2Fapi.spreaker.com%2Fdownload%2Fepisode%2F51339294%2Fchris_audio.mp3&podcastId=4100766"
    },
    {
        companyLogo: "Leaders-playbook-logo_.png",
        companyLogoAltText: "The Leader's Playbook Logo",
        articleTitle: "Entrepreneurship and Beyond with Chris Gay",
        articleSummary: "Join us on this episode as Justin is joined by Chris Gay, CEO and Cofounder of Evry Health, to discuss Evry Health, the in's and outs of business and entrepreneurship, and the importance of listening.",
        articleLink: "https://www.youtube.com/watch?app=desktop&v=4VUctgD_0sI"
    }, 
];

;// CONCATENATED MODULE: ./pages/news.js




// import classes from "../styles/section.module.css";

var News = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SEO/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "absolute inset-x-0 bottom-0 bg-gray-100 h-1/2"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mx-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "relative",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute inset-0"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-32",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                        className: "text-4xl tracking-tight text-blue-dark font-extralight sm:text-5xl lg:text-6xl",
                                                        children: [
                                                            "In the ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-globeGreen",
                                                                children: "news."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "mt-6 text-lg text-grey max-w-3xl",
                                                        children: "Stay up to date with the latest news and announcements from Evry Health and our impact in the healthcare industry."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "max-w-screen-xl px-4 py-16 mx-auto border-t-2 sm:px-6 lg:px-8 border-grey-light",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8",
                                    children: newsInfo.map(function(info) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card_InfoCard, {
                                                image: info.companyLogo,
                                                altText: info.companyLogoAltText,
                                                title: info.articleTitle,
                                                description: info.articleSummary,
                                                link: info.articleLink,
                                                linkText: info.linkText
                                            })
                                        }, info.articleLink);
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var news = (News);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [87,875,774,888,179], function() { return __webpack_exec__(5115); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);